import { render, staticRenderFns } from "./Browse.TemplateList.vue?vue&type=template&id=180c976b&scoped=true&"
import script from "./Browse.TemplateList.vue?vue&type=script&lang=js&"
export * from "./Browse.TemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180c976b",
  null
  
)

export default component.exports